import { makeQueryStringDync, errorServeiceHandler } from '../../helper'
const actions = {
  getManagePacksDetail: (context, filterData) => {
    //let url = 'subscriber/v1/product/active.php'
    let url = '/subscriber/v1/subscriber/services'
    return new Promise( (resolve, reject) => {
      //let queryStr = ''
      //queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        if (context.getters.getMode == "development") {
          resolve()
        }
        else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve()
          return
        }
        reject(error)
      });
    });
  }
};

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/mypacks/manage.js